import React, { useState, useEffect } from "react";
import {
  Button, Modal, ModalHeader, ModalBody,
  ModalFooter,
  FormGroup,
  Row,
  Col,
  Input,
  Label
} from "reactstrap";
import { Formik, Form } from "formik";
import { validateInit } from "./schema";
import { errorCode } from "../../../../utils/constants";
import LoaderUI from '../../../../components/common/loader';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toasterConfig, imageExtension } from "../../../../utils/constants";
import { validationMessage } from "../../../../utils/validation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { fetchMails} from "../../../../context/actions/document";
import { useDispatch } from "react-redux";

toast.configure();

const UnableToValidateModal = ({ currentFile,title, showModel, _toggle, addOperator, updateOperator, operatorDetail, disabled, locations, lodder, valiadationData, _saveUnableToValidateJsonData, disabledForm }) => {
  let errors = [];
  let [checkboxId, setCheckboxId] = useState([]);
  const dispatch = useDispatch();
  const [contacts, setContacts] = useState([]);

  const [contactList, setContactList] = useState([]);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    setCheckboxId([])
    // setContactList([])
  }, [showModel])

  useEffect(() => {
    const selectedContacts = contacts.filter(contact => contact.selected);
    setContactList(selectedContacts);
  }, [contacts, setContactList]);

  console.log('currentFile: ', currentFile)

  useEffect(() => {
    let isCancelled = false;
  
    if (showModel) {
      dispatch(fetchMails({ loanNumber: currentFile.loan_number, packetType: currentFile?.packet_type?.ml_ref }, (res) => {
        if (!isCancelled) {
          if (res.errors) {
            setMsg(res.errors.msg);
          } else if (res.contacts) {
            // Always reset contacts to API response to prevent stale selections
            setContacts(res.contacts.map(contact => ({ ...contact })));
            setInitiale(res.contacts); // Pass fetched contacts to set initial Formik values
          } else {
            setContacts([]);
          }
        }
      }));
    }
  
    return () => {
      isCancelled = true;
    };
  }, [showModel]);
  

  let note = '';
  let otherreason = false;
  let notify = false;
  // console.log('valiadationData.processedDocument.validationResult.userValidation',valiadationData.processedDocument.validationResult.userValidation)
  if (disabledForm && valiadationData?.processedDocument?.validationResult?.userValidation?.rejected) {
    if (valiadationData?.processedDocument?.validationResult?.userValidation?.rejected?.note) {
      note = valiadationData.processedDocument.validationResult.userValidation.rejected.note
      otherreason = true;
    }
    notify = valiadationData.processedDocument.validationResult.userValidation.rejected.notify;

  }


  valiadationData?.processedDocument?.errors && valiadationData.processedDocument.errors.map((data, id) => {
    let result;
    if (disabledForm && valiadationData?.processedDocument?.validationResult?.userValidation?.rejected?.errors) {
      result = valiadationData?.processedDocument.validationResult.userValidation.rejected.errors.find(obj => {
        return obj.resultKey == errorCode[data?.code] && obj?.errorCode == data?.code && obj?.errorMessage == data?.message
      })
    }
    errors.push({ ...data, key: errorCode[data?.code], defaultChecked: result ? result : false })
  });


  valiadationData?.processedDocument?.results && valiadationData.processedDocument.results.map((data, id) => {
    data?.processingResult?.errors?.length && data.processingResult.errors.map((item) => {
      let result;
      if (disabledForm && valiadationData?.processedDocument?.validationResult?.userValidation?.rejected?.errors) {
        result = valiadationData?.processedDocument.validationResult.userValidation.rejected.errors.find(obj => {
          return obj.resultKey == data.key && obj?.errorCode == item?.code && obj?.errorMessage == item?.message
        })
      }
      errors.push({ ...item, key: data.key, defaultChecked: result ? result : false })
    })
  });

  const [payload, setPlayload] = useState({
    ...validateInit
  });
 
  const setInitiale = (fetchedContacts) => {
    let obj = {};
    fetchedContacts.forEach((contact, i) => {
      obj[`notify_${i}`] = contact.selected || false;
    });
    setPlayload((prevValue) => ({ ...prevValue, ...obj }));
  };
  

  /**
   * @description method use to add operator
   * @param {object} params form params
   * @param {Instance} status form status/valiations err
   */
  const submitForm = (params, status) => {
    // let errors = checkboxId.map((item) => {
    //   return item.error
    // });
    let errors = checkboxId;
    if (!(errors.length || params?.otherreason)) {
      toast.error('Please check any reason', toasterConfig);
      return;
    } else if (params?.otherreason && !params.note.trim().length) {
      toast.error('Additional information can not be empty', toasterConfig);
      return;
    }

    if (contactList.length) {
      const invalidContacts = contactList.filter(
        (item) => item?.role && !item?.email
      );
      if (invalidContacts.length) {
        toast.error(
          <div>
            {invalidContacts.map((item, index) => (
              <div key={index}>
                Contact {item?.role} email cannot be empty.
              </div>
            ))}
          </div>,
          toasterConfig
        );
        return;
      }
    }

    if (valiadationData?.processedDocument?.validationResult) {
      valiadationData.processedDocument.validationResult.isValid = false;
      if (valiadationData?.processedDocument?.validationResult?.userValidation) {
        if (valiadationData?.processedDocument?.validationResult?.userValidation?.rejected) {
          valiadationData.processedDocument.validationResult.userValidation.rejected.errors = errors;

        } else {
          valiadationData.processedDocument.validationResult.userValidation.rejected = {};
          valiadationData.processedDocument.validationResult.userValidation.rejected.errors = errors;

        }
      } else {
        valiadationData.processedDocument.validationResult.userValidation = {};
        valiadationData.processedDocument.validationResult.userValidation.rejected = {};
        valiadationData.processedDocument.validationResult.userValidation.rejected.errors = errors;
      }
    } else {
      valiadationData.processedDocument.validationResult = { isValid: false };
      valiadationData.processedDocument.validationResult.userValidation = {};
      valiadationData.processedDocument.validationResult.userValidation.rejected = {};
      valiadationData.processedDocument.validationResult.userValidation.rejected.errors = errors;

    }

    valiadationData.processedDocument.validationResult.userValidation.isRejected = true;
    
    if(!contacts.length){
      valiadationData.processedDocument.validationResult.userValidation.rejected.notify = params.notify;
    }else{
      valiadationData.processedDocument.validationResult.userValidation.rejected.notify = contactList.length? true: false;//params.notify;
      valiadationData.processedDocument.validationResult.userValidation.rejected.notifyContact = contactList;
    }
    valiadationData.processedDocument.validationResult.userValidation.rejected.note = params.note;

    console.log("valiadationData",valiadationData.processedDocument.validationResult.userValidation.rejected);

    _saveUnableToValidateJsonData(valiadationData)






  };

  // const checkUncheckErrors = (val, index, item) => {


  //   if (val) {
  //     if (checkboxId.findIndex((cur) => cur?.index === index == -1)) {
  //       setCheckboxId((prev) =>
  //         [...prev, { index: index, error: { resultKey: item?.key, errorCode: item?.code, errorMessage: item?.message } }]
  //       );
  //     }

  //   } else {
  //     let i = checkboxId.findIndex((cur) => cur?.index === index)
  //     if (i !== -1) {
  //       checkboxId.splice(i, 1)
  //       setCheckboxId((prev) =>
  //         prev = checkboxId
  //       );
  //     }

  //   }

  //   console.log('setCheckboxId',checkboxId)
  // }



  const checkUncheckErrors = (val, index, item) => {


    if (val) {
      if (checkboxId.findIndex((cur) => (cur?.resultKey === item?.key && cur?.errorCode == item?.code) == -1)) {
        setCheckboxId((prev) =>
          [...prev, { resultKey: item?.key, errorCode: item?.code, errorMessage: item?.message }]
        );
      }

    } else {
      let i = checkboxId.findIndex((cur) => (cur?.resultKey === item?.key && cur?.errorCode == item?.code))
      if (i !== -1) {
        checkboxId.splice(i, 1)
        setCheckboxId((prev) =>
          prev = checkboxId
        );
      }

    }

    // console.log('setCheckboxId', checkboxId)
  }




  /**
    * @description method use to close add operator modal
    */
  const toggle = () => {


    _toggle()
  };




  return (
    <>
      <Modal isOpen={showModel} toggle={toggle} backdrop="static" className="validate-modal">
        <Formik
          initialValues={payload}
          enableReinitialize
          onSubmit={submitForm}
        >
          {(formik) => (
            <Form >
              <ModalHeader>
                {title}
                <Button color="link" onClick={toggle}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="34"
                    height="34"
                    viewBox="0 0 34 34"
                  >
                    <g data-name="Group 651" transform="translate(-1535 -134)">
                      <g
                        fill="#fff"
                        stroke="#000"
                        strokeWidth="2"
                        data-name="Ellipse 30"
                        opacity="0.3"
                        transform="translate(1535 134)"
                      >
                        <circle cx="17" cy="17" r="17" stroke="none"></circle>
                        <circle cx="17" cy="17" r="16" fill="none"></circle>
                      </g>
                      <path
                        d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
                        data-name="Icon ionic-ios-close"
                        opacity="0.3"
                        transform="translate(1534.289 132.789)"
                      ></path>
                    </g>
                  </svg>
                </Button>
              </ModalHeader>
              <ModalBody>
                <div className="row">
                  {errors.map(((item, index) => {
                    return (

                      <div className="col-sm-12 validation-error-list">
                        <Label className="">
                          <Input
                            type="checkbox"
                            name="error"
                            disabled={disabledForm}
                            defaultChecked={item?.defaultChecked}
                            onChange={(e) => {
                              formik.setFieldValue('error', e.target.checked);
                              checkUncheckErrors(e.target.checked, index, item)
                            }}
                          />
                          <span className="txt">
                            <strong>{item?.key}</strong> {' : ' + item?.title + ' , ' + item?.message}
                          </span>
                        </Label>
                      </div>

                    )
                  }))
                  }
                </div>
                <div className="col-sm-12 other-reason-rw">
                  <Label className="">
                    <Input
                      type="checkbox"
                      name="otherreason"
                      disabled={disabledForm}
                      defaultChecked={false || otherreason}
                      onChange={(e) => {
                        formik.setFieldValue('otherreason', e.target.checked);
                        if (!e.target.checked) {
                          formik.setFieldValue('note', '');
                        }
                      }}
                    />
                    <span className="txt">
                      {'Other reason'}
                    </span>
                  </Label>
                  {formik?.values?.otherreason || otherreason ?
                    <Col sm="12" className="add-info">
                      <Label>
                        {'Additional information'}
                      </Label>
                      <Input
                        type="textarea"
                        name="note"
                        disabled={disabledForm}
                        value={formik?.values?.note || note}
                        onChange={formik.handleChange}
                      />
                    </Col> : ''
                  }
                </div>
                <div className="loan-contacts-list">
                  <h3>Select Loan Contacts to Notify:</h3>
                  { msg &&  <span className="txt">
                              {msg}
                            </span>}
                  <div className="list-items d-flex flex-wrap">
                  {contacts &&
            contacts.map((contact, i) => (
              <Label key={i} className="">
                <Input
                  type="checkbox"
                  name={`notify_${i}`}
                  // Use Formik's value if available; otherwise, fallback to contact.selected.
                  checked={
                    typeof formik.values[`notify_${i}`] !== "undefined"
                      ? formik.values[`notify_${i}`]
                      : contact.selected
                  }
                  disabled={disabledForm}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    formik.setFieldValue(`notify_${i}`, isChecked);
                    setContacts((prevContacts) =>
                      prevContacts.map((c, index) =>
                        index === i ? { ...c, selected: isChecked } : c
                      )
                    );
                    if (isChecked) {
                      setContactList((prevValue) => [
                        ...prevValue,
                        { email: contact.email },
                      ]);
                    } else {
                      setContactList((prevValue) =>
                        prevValue.filter((c) => c.email !== contact.email)
                      );
                      formik.setFieldValue("notify", false);
                    }
                  }}
                />
                <span className="txt">
                  {contact.role} : {contact.email}
                </span>
              </Label>
            ))}
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Label className="notify-cell">
                  <Input
                    type="checkbox"
                    name="notify"
                    defaultChecked={notify ? true : false}
                    checked={formik.values[`notify`]}
                    disabled={disabledForm}
                    onChange={(e) => {
                      formik.setFieldValue('notify', e.target.checked);
                      if (e.target.checked) {
                        contacts.forEach((contact, i) => {
                          formik.setFieldValue(`notify_${i}`, true);
                          setContactList((prevValue) => ([ ...prevValue, { ...contact, selected:true } ]))
                        });
                      } else {
                        contacts.forEach((contact, i) => {
                          formik.setFieldValue(`notify_${i}`, false);
                          setContactList([])
                        });
                      }
                    }}
                  />
                  <span className="txt">
                    {'Notify all contacts'}
                  </span>
                </Label>

                <Button color="link" onClick={toggle} className="cancel-btn">
                  Cancel
                </Button>
                <Button
                  disabled={disabled || disabledForm}
                  color="secondary"
                  type="submit"
                >
                  {'Submit'}
                </Button>
              </ModalFooter>
            </Form>)}
        </Formik> 
      </Modal>
      {lodder && <LoaderUI className="modal-overlay-level-1" overlay />}
    </>
  );
};

export default UnableToValidateModal;